/* eslint-disable arrow-parens */
function passwordToggleClass(btn) {
	const input = btn.parentNode.querySelector('input');

	if (btn.classList.contains('close')) {
		btn.classList.remove('close');
		btn.classList.add('open');
		input.type = 'text';
	} else {
		btn.classList.add('close');
		btn.classList.remove('open');
		input.type = 'password';
	}
}

function init() {
	document.querySelectorAll('.show-password-js.close').forEach(el => {
		el.addEventListener('click', (e) => {
			passwordToggleClass(e.currentTarget);
		});
	});
}

export default {
	init,
};
